<template>
  <div :class="'flex flex-col ' + size">
    <slot name="label">
      <label :for="props.name" :class="props.classes">{{ label }}</label>
    </slot>
    <slot :value="value" :errorMessage="errorMessage">
      <InputNumber
        class="h-10"
        :name="props.name"
        v-model="value"
        :mode="props.mode"
        :showButtons="props.showButtons"
        increment-button-class="py-0!"
        decrement-button-class="py-0!"
        :min="props.min"
        :max="props.max"
        :currency="currency"
      />
      <small v-if="errorMessage" :id="props.name + '-help'" class="text-red-500">{{ errorMessage }}</small>
    </slot>
  </div>
</template>

<script setup lang="ts">
import { useField } from "vee-validate";
import { computed } from "vue";

interface Props {
  name: string;
  value?: number;
  label: string;
  size?: string;
  classes?: string;
  disabled?: boolean;
  showButtons?: boolean;
  min?: number;
  max?: number;
  mode?: "decimal" | "currency";
}
const props = withDefaults(defineProps<Props>(), {
  size: "w-full",
  classes: "font-bold",
  disabled: false,
  showButtons: false,
  mode: "decimal",
});

const currency = computed<string | undefined>(() => (props.mode === "currency" ? "USD" : undefined));

const { value, errorMessage } = useField<number>(() => props.name);
</script>
